<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
        <g :fill="color" fill-rule="nonzero">
            <path d="M13.682 0H1.318A1.32 1.32 0 0 0 0 1.318v8.848a1.32 1.32 0 0 0 1.318 1.318h3.985v.88h-.44a1.32 1.32 0 0 0-1.318 1.318v.879c0 .242.197.439.44.439h7.03a.44.44 0 0 0 .44-.44v-.878a1.32 1.32 0 0 0-1.318-1.319h-.44v-.879h3.985A1.32 1.32 0 0 0 15 10.166V1.318A1.32 1.32 0 0 0 13.682 0zm-3.545 13.242a.44.44 0 0 1 .44.44v.44H4.423v-.44a.44.44 0 0 1 .44-.44h5.273zm-3.955-.879v-.879h2.636v.88H6.182zm7.94-2.197a.44.44 0 0 1-.44.44H1.318a.44.44 0 0 1-.44-.44V1.318a.44.44 0 0 1 .44-.44h12.364a.44.44 0 0 1 .44.44v8.848z"/>
            <path d="M11.771 2.03c-1.442-.542-3.16-.392-4.596.687-1.43-1.075-3.148-1.23-4.597-.686a.417.417 0 0 0-.278.386v5.558a.41.41 0 0 0 .195.345.467.467 0 0 0 .413.042 3.849 3.849 0 0 1 3.638.507c.377.283.39.302.483.333a.5.5 0 0 0 .145.023h.001c.206 0 .309-.116.629-.356a3.849 3.849 0 0 1 3.638-.507.468.468 0 0 0 .413-.042.41.41 0 0 0 .195-.345V2.417c0-.17-.11-.323-.279-.387zm-5.04 5.94a4.812 4.812 0 0 0-3.545-.563V2.71c1.146-.332 2.347-.162 3.546.74v4.518zm4.432-.564a4.797 4.797 0 0 0-3.545.563V3.45c1.206-.906 2.41-1.068 3.545-.739v4.695z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "OnlineIcon",
        props: {
            isDarker: {
                type: Boolean,
                default() {
                    return false;
                },
            },
            color: {
                type: String,
                default() {
                    return this.isDarker ? '#263238' : '#ABABAB';
                },
            },
        },
    }
</script>

<style scoped>

</style>
